import { FEATURE_TOGGLE, UserProfileEnum } from '@constants';
import { useAuth } from '@hooks';
import { CompanySummary } from 'components/CompanySummary';
import { BillsSummary } from 'components/BillsSummary';

import { MovementsSummary } from '../MovementsSummary';
import { HomeQuickActions } from '../HomeQuickActions';
import { HomeBanner } from '../HomeBanner';
import { BeneficiariesSummary } from '../BeneficiariesSummary';

export function HomeItemsList() {
  const { selectedPartnerCompany } = useAuth();

  const { name = '' } = selectedPartnerCompany?.profile ?? {};

  const isFinancial = name === UserProfileEnum.FINANCIAL;
  const isMovement = name === UserProfileEnum.MOVEMENT;

  if (isMovement) {
    return (
      <>
        <HomeBanner />
        <CompanySummary />

        {FEATURE_TOGGLE.BENEFICIARIES_V3 && <BeneficiariesSummary />}

        <MovementsSummary />
      </>
    );
  }

  if (isFinancial) {
    return (
      <>
        <HomeBanner />
        <CompanySummary />

        <BillsSummary />
      </>
    );
  }

  return (
    <>
      <HomeBanner />
      <CompanySummary />

      <HomeQuickActions />

      {FEATURE_TOGGLE.BENEFICIARIES_V3 && <BeneficiariesSummary />}

      <BillsSummary />

      <MovementsSummary />
    </>
  );
}
